import moment from 'moment'
const initialState = {
  currentTemplate: {},
  ageOptions: [
    { name: 'under18', title: '< 18' },
    { name: 'above18', title: 'more or equal 18' }
  ],
  searchParams: {
    age: {},
    start_date: null,
    end_date: null,
    country: {},
    mechanic: {}
  },
  templatesPerPage: 10
}

export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setCurrentTemplate(state, template) {
      state.currentTemplate = template
    },
    setSearchParams(state, params) {
      state.searchParams = params
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    searchTemplates({ dispatch, commit, state }, { name, startDate, country, age, mechanic, allTemplates, offset }) {
      const params = {
        name: name || null,
        start_date: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
        country: country ? country.id : null,
        age: age ? age.name : null,
        mechanic: mechanic ? mechanic.id : null,
        allTemplates: allTemplates || null
      }
      const searchParams = Object.assign({}, params)
      searchParams.age = age
      searchParams.country = country
      commit('setSearchParams', searchParams)
      params.limit = state.templatesPerPage
      params.offset = offset
      return dispatch(
        'app/makeCall',
        {
          route: 'templates.getList',
          payload: params
        },
        { root: true }
      ).then((response) => {
        return response.data
      })
    },
    setCurrentTemplate({ dispatch, commit }, { id }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'templates.getTemplateById',
          payload: id
        },
        { root: true }
      ).then((response) => {
        commit('setCurrentTemplate', response.data)
      })
    },
    async getAssignedCountries({ dispatch }, { id }) {
      try {
        const res = await dispatch(
          'app/makeCall',
          {
            route: 'templates.getAssignedCountries',
            payload: id
          },
          { root: true }
        )
        return res.data
      } catch (e) {
        throw e.response
      }
    },
    async createTemplate({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'templates.createTemplate',
            payload
          },
          { root: true }
        )
      } catch (error) {
        throw error.response
      }
    },
    async updateTemplate({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'templates.updateTemplate',
            payload
          },
          { root: true }
        )
      } catch (error) {
        throw error.response
      }
    },
    async deleteTemplate({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'templates.deleteTemplate',
            payload
          },
          { root: true }
        )
      } catch (error) {
        throw error.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/template.js